import store from '@store';
const autoGeneratedListingContentPayload = ({ values, content_type }) => {
  const isDailyRentalListing = values?.listing_purpose?.slug === 'daily-rental';
  return {
    content_type: content_type,
    purpose_name: values?.listing_purpose?.title,
    type: isDailyRentalListing
      ? values?.property_type_label
      : values?.sub_listing_type?.label || values?.listing_type?.title,
    city: values?.location?.city_id,
    location: values?.location?.title,
    area: values?.area_unit?.value,
    furnished: isDailyRentalListing ? 'yes' : values?.furnished === '1' ? 'yes' : 'no',
    rental_frequency: isDailyRentalListing ? 1 : values?.listing_purpose?.title === 'Rent' && values?.rental_frequency,
    area_unit: values?.area_unit?.id,
    price:
      values?.listing_purpose?.title === 'Rent'
        ? values?.rental_price
          ? parseInt(values?.rental_price)
          : 0
        : values?.price
          ? parseInt(values?.price)
          : 0,
    beds: parseInt(values?.bedrooms) || null,
    baths: parseInt(values?.bathrooms) || null,
  };
};

const findFeatureById = (arr, featureId) => {
  for (const group of arr) {
    const feature = group.features.find((feature) => feature.feature_id == featureId);
    if (feature) {
      return feature?.id;
    }
  }
  return null;
};

const getListingFeatures = (featuresAmenities, listingFeatures) =>
  featuresAmenities && Object.keys(featuresAmenities)?.length
    ? Object.keys(featuresAmenities)
        .map((e) =>
          !!findFeatureById(listingFeatures, e)
            ? {
                id: findFeatureById(listingFeatures, e),
                feature_id: e,
                ...(featuresAmenities?.[e] == undefined || featuresAmenities?.[e] == false
                  ? { _destroy: true }
                  : { feature_value: featuresAmenities?.[e] === true ? 'Yes' : featuresAmenities?.[e] }),
              }
            : featuresAmenities?.[e]
              ? { feature_id: e, feature_value: featuresAmenities?.[e] === true ? 'Yes' : featuresAmenities?.[e] }
              : null,
        )
        .filter((e) => !!e)
    : [];

const getUpdateListingPayload = ({ values, listing, autoRenew, productId, source }) => {
  const locale = store.getState().app.AppConfig.locale;
  const isSellOrRentProperty = values?.listing_purpose?.slug == 'sale' || values?.listing_purpose?.slug == 'rent';
  const isDailyRentalListing = values?.listing_purpose?.slug == 'daily-rental';
  const isOffPlan = values?.is_offplan_listing;
  const images = values.property_images?.length
    ? values.property_images
        .filter((e) => e.uuid)
        .map((image) => {
          const { id, uuid, isMainImage, _destroy, order } = image;
          return {
            name: uuid,
            is_main_image: !!isMainImage,
            order: order,
            // TODO: need to fix this
            ...(id && typeof id === 'number' && { id }),
            _destroy,
          };
        })
    : [];

  const mainImageIndex = images.findIndex((e) => !!e.is_main_image);
  if (mainImageIndex != -1) {
    const mainImage = images.splice(mainImageIndex, 1);
    images.unshift(mainImage?.[0]);
  } else {
    const index = images.findIndex((e) => !e?._destroy);
    images[index] = { ...images[index], is_main_image: true };
  }
  return {
    listing: {
      source,
      purpose_id: values?.purpose,
      ...(isSellOrRentProperty
        ? { type_id: values?.sub_listing_type?.id || values?.listing_type?.id }
        : { type_id: values?.property_type }),
      ...(values?.listing_type?.id
        && { type_id: values?.listing_type?.id }),
      latitude: values?.['location-info']?.map?.latitude || values?.latitude || values?.location?.latitude,
      longitude: values?.['location-info']?.map?.longitude || values?.longitude || values?.location?.longitude,
      ...(isSellOrRentProperty && {
        is_furnished: values?.furnished == '1',
      }),
      ...(isSellOrRentProperty && {
        area_unit_id: values?.area_unit?.id,
      }),
      area_unit_value: isOffPlan || !isSellOrRentProperty ? values?.area : values?.area_unit?.value,
      ...(isDailyRentalListing && {
        national_address: values?.national_address,
        redirection_link: values?.redirection_link,
      }),
      ...(values?.residence_type_applicable && { residence_type: values?.residence_type }),
      listing_features_attributes: getListingFeatures(values?.feature_and_amenities, listing?.listing_features),
      beds: values?.bedrooms,
      bath: values?.bathrooms,
      price: values?.listing_purpose?.slug == 'sale' || isDailyRentalListing ? values?.price : values?.rental_price,
      ...(values?.listing_purpose?.slug == 'rent' && { rental_price: values?.rental_price }),
      listing_images_attributes: images?.length ? images.map((image, index) => ({ ...image, order: index })) : [],
      listing_videos_attributes: values?.videos?.length
        ? values?.videos
            .filter((e) => e.id || (!e.id && !e._destroy))
            .map((e) => ({
              ...(e.id && { id: e.id }),
              video_host: 'youtube',
              video_title: '',
              video_link: e?.url,
              ...(e._destroy && { _destroy: e._destroy }),
            }))
        : [],
      title: locale == 'ar' && values?.generate_title ? listing?.title : values?.property_title_en,
      title_l1: locale == 'en' && values?.generate_title ? listing?.title_l1 : values?.property_title_ar,
      description:
        locale == 'ar' && values?.generate_description ? listing?.description : values?.property_description_en,
      description_l1:
        locale == 'en' && values?.generate_description ? listing?.description_l1 : values?.property_description_ar,
      title_translation_enabled: values?.generate_title,
      description_translation_enabled: values?.generate_description,
      platform_id: 1,
      ...(isSellOrRentProperty && {
        rent_frequency_id: values?.rental_frequency,
      }),
      is_autorenewal_on: autoRenew,
      location_id: values?.['location-info']?.location?.location_id
        ? values?.['location-info']?.location?.location_id
        : values?.['location-info']?.city?.id,
      additional_details: values?.additional_details || null,
      booked: values?.booked,
      ...(isOffPlan && {
        unit_no: values?.additional_number,
        sale_type: values?.sale_type || null,
        type_id: values?.property_type,
        unit_variant: values?.unit_variant,
        completion_status: values?.completion_status,
      }),
    },
    product_id: productId,
  };
};

export default { autoGeneratedListingContentPayload, getUpdateListingPayload };
